/**
 * Filter endpoints
 * Includes:
 *  - search url
 *  - filters url
 *  - clone url
 *  - delete url
 */

export interface FILTER_END_POINTS_TYPES {
  search?: string
  filters: string
  clone?: string
  delete?: string
}

export const FILTER_END_POINTS: FILTER_END_POINTS_TYPES = {
  search: '/search',
  filters: '/filters',
  clone: '/filters/clone',
  delete: '/filters'
};
